angular.module('unergie.main')
.directive('columnchooser', () =>
    ({
        restrict: 'E',
        templateUrl: '/directives/columnchooser/columnchooser.html',
        transclude: true,
        scope: {
            columns: '=',
            prefix: '=',
            show: '=?',
            refreshParent: '=',
            mini: '=',
        },
        link($scope) {
            $scope.columnsPayload = {}
            $scope.columnFields = {}

            if ($scope.show === undefined) {
                $scope.$parent.show = $scope.$parent.show || {}
            }

            const updateParent = function (colName, value) {
                if ($scope.show === undefined) {
                    $scope.$parent.show[colName] = value
                    return
                }
                $scope.show[colName] = value
            }

            $scope.saveColumns = function () {
                _.forEach($scope.columns, (c, key) => {
                    if (c) {
                        const value = c.mode === 'hidden' ? false : $scope.columnsPayload[$scope.prefix + key]
                        updateParent(key, value)
                        localStorage[$scope.prefix + key] = `${value}`
                    }
                })
                if ($scope.refreshParent) {
                    $scope.refreshParent()
                }
            }

            return $scope.$watch('columns', () =>
                _.forEach($scope.columns, (c, key) => {
                    if (c) {
                        const isVisible = _.defaultTo(c.isVisible, true)
                        $scope.columnsPayload[$scope.prefix + key] = c.forceVisible || (localStorage[$scope.prefix + key] !== undefined ? localStorage[$scope.prefix + key] === 'true' : isVisible)
                        updateParent(key, (c.mode === 'hidden' ? false : $scope.columnsPayload[$scope.prefix + key]))
                        if (c.mode !== 'hidden') {
                            $scope.columnFields[$scope.prefix + key] = {
                                label: c.label,
                                type: 'checkbox',
                            }
                        }
                    }
                })
            )
        },
    })
)
